import ApiServiceV6 from '@/helpers/api.service.v6lite';
const APIV6Lite = new ApiServiceV6();


export const state = {
   networksList: [],
   networkCategoryList: []
   
}

export const mutations = {
    UPDATE_NETWORKS_LIST(state, value) {
        state.networksList = value;
    },
    UPDATE_NETWORK_CATEGORY_LIST(state, value) {
        state.networkCategoryList = value;
    }
}

export const actions = {
    fetchLiteNetworksList(context, params) {
        return new Promise((resolve, reject) => {
            APIV6Lite.get(`/eload/dropdown/networks`, params)
            .then((response) => {
                context.commit('UPDATE_NETWORKS_LIST', response.data.message.rows);
                resolve(response.data);
            }
            )
            .catch((error) => {
                reject(error);
            });
        });
    },
    fetchLiteNetworkCategoryList(context, params) {
        return new Promise((resolve, reject) => {
            APIV6Lite.get(`/eload/dropdown/network-categories`, params)
            .then((response) => {
                context.commit('UPDATE_NETWORK_CATEGORY_LIST', response.data.message.rows);
                resolve(response.data);
            }
            )
            .catch((error) => {
                reject(error);
            });
        });
    },
}

export const getters = {
   
}